import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';
import { Observable, Subscription, iif, map, of, switchMap } from 'rxjs'
import { Store } from '@ngrx/store';

import { GlobalState } from '@core/global-state/app.reducer';

import { ContainerAuthFunctions } from './container-auth.functions';
import { SizesDevice } from '@shared/models/constants/global.constants';
import { StaticFilesManager } from '@core/static-serve/static-serve.manager';
import { CStaticResourceType } from '@core/static-serve/models/constants/static-serve.constants';

@Component({
    selector: 'mdk-container-auth',
    templateUrl: './container-auth.component.html',
    styleUrls: ['./container-auth.component.scss'],
})
export class ContainerAuthComponent implements OnInit, OnDestroy {

  //#region [---- [PROPERTIES] ----]

    // Size Detection (Responsive)
    isMobile: boolean = false
    showImageBannerMobile:boolean = false
    isShowingModakLogo:boolean = false;

    @Input() useImageHeader:boolean = false;

    private readonly subscription: Subscription = new Subscription();

  //#endregion

  //#region [---- INJECTION DEPENDENCIES----]

  private readonly store:Store<GlobalState> = inject(Store<GlobalState>)
  private readonly authParentFunctions:ContainerAuthFunctions = inject(ContainerAuthFunctions)
  private readonly staticFilesManager:StaticFilesManager = inject(StaticFilesManager)

  imageUrl:string;

  //#endregion

    ngOnInit(): void {
        this.imageUrl = `${this.staticFilesManager.getUrlStaticServer(CStaticResourceType.IMAGES)}/auth.webp`
        this.listenResponsive();
        this.listenShowAuthComponent();
        this.listenShowModakLogo();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private listenResponsive(): void {
        const responsiveSubscription = this.getIsMobile().subscribe({
            next: isMobile => {
                this.isMobile = isMobile;
                this.showImageBannerMobile = this.isMobile
            }
        })
        this.subscription.add(responsiveSubscription);
    }

    private listenShowModakLogo(): void {
        this.authParentFunctions.observeShowingModakLogo()
        .subscribe({
            next: isShowingModakLogo => this.isShowingModakLogo = isShowingModakLogo
        })
    }

    private listenShowAuthComponent(): void {   
        this.getIsMobile()
        .pipe(
            switchMap((isMobile) => {
                return iif(() => isMobile, this.authParentFunctions.observeShowingAuth(), of(isMobile))
            })
        ).subscribe({
            next: value => this.showImageBannerMobile = value 
        })
    }

    private getIsMobile(): Observable<boolean> {
        return this.store.select((state: GlobalState) => state.responsive).pipe(
            map((state) => state.sizeDevice === SizesDevice.MOBILE)
        )
    }
}
